<template>
  <div>
    <Table
      :columns="columns"
      :data="getOrderedProducts"
      :is-accessible="true"
      @view="redirectToProductPage"
      :is-selectable="true"
      :selectable-row-filter="approvedAndMatched"
      @newSelectedRows="$emit('newSelectedRows', $event)"
    >
      <template #title="{ row }">
        <div class="flex space-x-2 min-w-64 max-w-md whitespace-normal">
          <span>{{ row.title }}</span>
          <VTooltip v-if="toBeApproved(row)" theme="info-tooltip">
            <InformationCircleIcon class="cursor-pointer h-5 w-4 text-gray-400" aria-hidden="true" />

            <template #popper>
              <slot name="tooltip">
                <span>Le produit doit être validé par Estaly pour pouvoir proposer une offre d'assurance dessus</span>
              </slot>
            </template>
          </VTooltip>
        </div>
      </template>

      <template #contractStatus="{ row }">
        <FieldSpan :style-to-add="getContractStatusStyle(row)" :value="row.contractStatus" />
      </template>

      <template #enabled="{ row }">
        <FieldSpan :style-to-add="getEnabledFieldStyle(row)" :value="row.enabled ? 'Oui' : 'Non'" />
      </template>
    </Table>
  </div>
</template>

<script>
import { Table, FieldSpan } from "@estaly/ui";
import { InformationCircleIcon } from "@heroicons/vue/outline";
import { mapGetters } from "vuex";

export default {
  components: {
    InformationCircleIcon,
    Table,
    FieldSpan,
  },
  props: ["products"],

  computed: {
    ...mapGetters("products", ["getEnabledFieldStyle", "getContractStatusStyle", "toBeApproved", "approvedAndMatched"]),

    columns() {
      return [
        {
          label: "Produit",
          field: "title",
          slot: "title",
        },
        {
          label: "Catégorie",
          field: "productType",
        },
        {
          label: "Référence",
          field: "referenceId",
        },
        {
          label: "Statut du contrat",
          field: "contractStatus",
          slot: "contractStatus",
        },
        {
          label: "Offre déployée",
          field: "enabled",
          slot: "enabled",
        },
      ];
    },

    getOrderedProducts() {
      return [...this.products].sort((a, b) => (a.enabled < b.enabled ? 1 : -1));
    },
  },
  methods: {
    redirectToProductPage(product) {
      this.$router.push(`/platform/products/${product.id}`);
    },
  },
};
</script>
